import React, { FC } from 'react'
import { Modal, Button } from 'antd'
import { ModalProps } from 'antd/lib/modal'

// assets
import { ReactComponent as CloseIcon } from '../../assets/icons/BaseIcons/x-icon.svg'

type Props = ModalProps & {
	isVisible: boolean
	title: string
	message: string
	onConfirm: Function
	onCancel: any
	onConfirmBtnTitle: string
	classNameBtn?: string
	disabled?: boolean
	onConfirmBtnWidth?: number
}

const ConfirmationModal: FC<Props> = (props) => {
	const { isVisible, title, message, onConfirm, onCancel, width, onConfirmBtnTitle, cancelText, classNameBtn, className, onConfirmBtnWidth, disabled } = props

	return (
		<Modal
			className={className}
			closeIcon={<CloseIcon width={18} height={18} />}
			title={title}
			centered
			open={isVisible}
			width={width}
			onCancel={onCancel}
			footer={[
				<Button disabled={disabled || false} className={'h-10'} style={{ width: 118 }} key='back' type='text' onClick={onCancel}>
					{cancelText}
				</Button>,
				<Button
					style={{ width: onConfirmBtnWidth || 118, height: 40 }}
					className={classNameBtn || ''}
					disabled={disabled || false}
					key='submit'
					type='primary'
					onClick={() => {
						onConfirm()
					}}
				>
					{onConfirmBtnTitle}
				</Button>
			]}
		>
			<p>{message}</p>
		</Modal>
	)
}

export default ConfirmationModal
